function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { getOtherProps } from '../util';
var returnToTop = function returnToTop(e) {
  e.preventDefault();
  window.scrollTo(0, 0);
};
var TYPE_SMALL = 'small';
var TYPE_MEDIUM = 'medium';
var TYPE_LARGE = 'large';
var Footer = function Footer(props) {
  var otherProps = getOtherProps(Footer.propTypes, props);
  var className = props.type === TYPE_MEDIUM ? 'wds-c-footer' : "wds-c-footer wds-c-footer--".concat(props.type);
  return /*#__PURE__*/React.createElement("footer", _extends({}, otherProps, {
    className: className
  }), props.returnToTopLinkTitle && /*#__PURE__*/React.createElement("div", {
    className: "wds-l-grid wds-c-footer__return-to-top"
  }, /*#__PURE__*/React.createElement("a", {
    href: "",
    className: "wds-c-link",
    onClick: returnToTop
  }, props.returnToTopLinkTitle)), React.Children.map(props.children, function (child) {
    if (child && props.type === TYPE_LARGE) {
      return /*#__PURE__*/React.cloneElement(child, {
        largeFooter: true
      });
    }
    return child;
  }));
};
export default Footer;
Footer.propTypes = {
  /**  the children to the footer */
  children: PropTypes.node,
  /**  type of footer */
  type: PropTypes.oneOf([TYPE_SMALL, TYPE_MEDIUM, TYPE_LARGE]),
  /** return to top link title */
  returnToTopLinkTitle: PropTypes.string
};
Footer.defaultProps = {
  children: undefined,
  type: TYPE_SMALL,
  returnToTopLinkTitle: undefined
};
Footer.displayName = 'Footer';